module.exports = __webpack_public_path__ + "static/red_right-98c79bc58a90d1af7352d1fb2ed8e816.png";